import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { People, people } from './sample-data';


export class Group {
  level: number = 0;
  parent: Group;
  expanded: boolean = true;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}

/**
 * @title Basic use of `<table mat-table>`
 */
@Component({
  selector: 'app-table-basic-example',
  templateUrl: './table-basic-example.component.html',
  styleUrls: ['./table-basic-example.component.scss']
})
export class TableBasicExampleComponent {

  displayedColumns: string[] = ['surname', 'forename', 'gender', 'ukCity', 'salary', 'department'];
  public dataSource = new MatTableDataSource<People | Group>([]);

  public newDataSource = new MatTableDataSource<People | Group>([]);

  groupByColumns: string[] = ['gender', 'salary', 'department'];

  constructor() {
    this.dataSource.data = this.addGroups(people, this.groupByColumns);
    console.log('datasource data', this.dataSource.data);
    // copy the data returned from addGroups into a new Group
    let levelCheck = this.groupByColumns.length;
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i] instanceof Group) {

        console.log('Its a group', this.dataSource.data[i]);
        let groupVal = this.dataSource.data[i] as Group;

        console.log('groupVal.level', groupVal.level);
        if (groupVal.level !== levelCheck) {
          console.log('continue');
          continue;
        }
      }
      this.newDataSource.data.push(this.dataSource.data[i]);
    }
    console.log(this.newDataSource.data);
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);
  }

  customFilterPredicate(data: People | Group, filter: string): boolean {
    return (data instanceof Group) ? data.visible : this.getDataRowVisible(data);
  }

  getDataRowVisible(data: People): boolean {
    const groupRows = this.dataSource.data.filter(
      row => {
        if (!(row instanceof Group)) return false;

        let match = true;
        this.groupByColumns.forEach(
          column => {
            if (!row[column] || !data[column] || row[column] !== data[column]) match = false;
          }
        );
        return match;
      }
    );

    if (groupRows.length === 0) return true;
    if (groupRows.length > 1) throw "Data row is in more than one group!";
    const parent = <Group>groupRows[0];  // </Group> (Fix syntax coloring)

    return parent.visible && parent.expanded;
  }

  groupHeaderClick(row) {
    row.expanded = !row.expanded
    this.dataSource.filter = performance.now().toString();  // hack to trigger filter refresh
  }

  addGroups(data: any[], groupByColumns: string[]): any[] {
    var rootGroup = new Group();
    console.log('this.getSublevel(data, 0, groupByColumns, rootGroup)')
    var callSubLevelToAddGroups = this.getSublevel(data, 0, groupByColumns, rootGroup);
    console.log(callSubLevelToAddGroups)
    return callSubLevelToAddGroups; //this.getSublevel(data, 0, groupByColumns, rootGroup);
  }

  getSublevel(data: any[], level: number, groupByColumns: string[], parent: Group): any[] {
    // Recursive function, stop when there are no more levels. 
    if (level >= groupByColumns.length)
      return data;

    var groups = this.uniqueBy(
      data.map(
        row => {
          var result = new Group();
          result.level = level + 1;
          result.parent = parent;
          for (var i = 0; i <= level; i++)
            result[groupByColumns[i]] = row[groupByColumns[i]];
          return result;
        }
      ),
      JSON.stringify);

    const currentColumn = groupByColumns[level];
    console.log('currentColumn', currentColumn);

    var subGroups = [];
    groups.forEach(group => {
      console.log('group', group)
      let rowsInGroup = data.filter(row => group[currentColumn] === row[currentColumn])
      console.log('rowsInGroup', rowsInGroup)
      let subGroup = this.getSublevel(rowsInGroup, level + 1, groupByColumns, group);
      console.log('subGroup', subGroup);
      subGroup.unshift(group);
      console.log('subGroup unshift', subGroup);
      subGroups = subGroups.concat(subGroup);
      console.log('subGroups', subGroups);
    })
    return subGroups;
  }

  uniqueBy(a, key) {
    var seen = {};
    return a.filter(function (item) {
      var k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    })
  }

  isGroup(index, item): boolean {
    return item.level;
  }
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */